<template>
	<Layout header-class="header-left-align" nav-alignment="left" :topbar-style="2">
		<!-- Start Slider area -->
		<div class="slider-area slider-style-2 variation-2 height-450 bg_image"
				 :style="{'background-image': `url(${require(`@/assets/images/bwt/base-banner.jpg`)})`}">
			<div class="container">
				<div class="row">
					<div class="col-lg-8 col-xl-6">
						<div class="inner text-start" data-aos="fade-up" data-aos-delay="100">
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">产品及解决方案</h2>
				<div class="product" data-aos="fade-up" data-aos-delay="100">
					<div class="swiper-container">
						<div class="swiper-wrapper">
							<div class="swiper-slide">
								<div class="eee">
									<div class="t1">AI算力服务器</div>
									<div class="t2">基于鲲鹏处理器和昇腾AI处理器推出的新一代ARM人工智能计算服务器，具有超强算力、全场景 Al 和开放生态等特点，主要为图像识别、视频处理、推理计算及机器学习等场景提供解决方案，广泛应用于平安城市、智慧交通、智能制造、智能营业厅、无人零售、智能楼宇等领域。</div>
								</div>
								<div class="pic">
									<img src="@/assets/images/bwt/base1.jpg">
								</div>
							</div>
							<div class="swiper-slide">
								<div class="eee">
									<div class="t1">通用算力服务器</div>
									<div class="t2">基于鲲鹏处理器推出的新一代 ARM 数据中心服务器，主要面向存储业务，具有海量存储、高性能、低功耗以及易扩展的特点，适合为大数据分析软件定义存储等应用场景的工作负载进行高效加速。</div>
								</div>
								<div class="pic">
									<img src="@/assets/images/bwt/base2.jpg">
								</div>
							</div>
							<div class="swiper-slide">
								<div class="eee">
									<div class="t1">计算终端产品</div>
									<div class="t2">基于飞腾处理器推出的国产化商用台式机。兼容业界主流内存、硬盘、网卡等硬件，支持Linux 桌面操作系统，具有高性能、接口丰富、高可靠性、易用性等特点。</div>
								</div>
								<div class="pic">
									<img src="@/assets/images/bwt/base3.jpg">
								</div>
							</div>
							<div class="swiper-slide">
								<div class="eee">
									<div class="t1">数据通信产品</div>
									<div class="t2">面向云计算、移动互联网、物联网等ICT浪潮，推出了一系列包含网络交换机、路由器、无线接入点等软硬件设备，满足企业级用户对数据传输速度、安全性和可靠性的高标准。集成先进网络技术，支持多种通信协议，确保数据在不同设备和平台之间无缝、高效传输。</div>
								</div>
								<div class="pic">
									<img src="@/assets/images/bwt/base4.jpg">
								</div>
							</div>
						</div>
						<div class="swiper-pagination"></div>
					</div>
				</div>
			</div>
		</div>


	</Layout>
</template>

<script>
import Layout from '@/components/common/Layout'
import Separator from '@/components/elements/separator/Separator'
import Swiper from "swiper";
import "swiper/css/swiper.css";
export default {
	name: 'Solution1',
	components: {Separator, Layout},
	data() {
		return {

		}
	},
	mounted() {
		new Swiper(".swiper-container", {
			autoplay: true,
			delay: 2000,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				renderBullet: function (index, className) {
					return '<span class="' + className + '">' + (index + 1) + "</span>";
				},
			},
		});
	}
}
</script>
<style lang="scss" scoped>
.sbg {
	background-image: url("../../../assets/images/bwt/sbg.jpg");
}
.product {
	margin-top: 72px;
	display: flex;
	.swiper-container {
		width: 100%;
		height: 100%;
		.swiper-wrapper {
			width: 100%;
		}
		.swiper-slide {
			width: 100%;
			text-align: center;
			font-size: 18px;
			background: #fff;
			display: flex;
			justify-content: center;
			align-items: flex-start;
			.pic {
				width: 40%;
				img {
					width: 100%;
					border-radius: 10px;
				}
			}

			.eee {
				width: 60%;
				padding-right: 40px;
				text-align: left;
				margin-top: 8%;
				.t1 {
					font-size: 24px;
					font-weight: 600;
					color: #000;
				}
				.t2 {
					margin-top: 12px;
					color: #000;
				}
			}
		}
		:deep(.swiper-pagination) {
			top: 80%;
			width: 50%;
		}

		:deep(.swiper-pagination-bullet) {
			width: 20px;
			height: 20px;
			text-align: center;
			line-height: 20px;
			font-size: 12px;
			color: #000;
			opacity: 1;
			background: rgba(0, 0, 0, 0.2);
		}

		:deep(.swiper-pagination-bullet-active){
			color: #fff;
			background: #007aff;
		}
	}
}
</style>
